var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 31.5601H6.4C5.08 31.5601 4 30.4801 4 29.1601V13.9601C4 12.6401 5.08 11.5601 6.4 11.5601H25.6C26.92 11.5601 28 12.6401 28 13.9601V29.1601C28 30.4881 26.92 31.5601 25.6 31.5601ZM6.4 13.1601C5.96 13.1601 5.6 13.5201 5.6 13.9601V29.1601C5.6 29.6001 5.96 29.9601 6.4 29.9601H25.6C26.04 29.9601 26.4 29.6001 26.4 29.1601V13.9601C26.4 13.5201 26.04 13.1601 25.6 13.1601H6.4Z",
    fill: "#353EBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.96 13.16C23.52 13.16 23.16 12.8 23.16 12.36V9.56005C23.16 5.61605 19.952 2.40005 16 2.40005C12.048 2.40005 8.83999 5.61605 8.83999 9.56005V12.36C8.83999 12.8 8.47999 13.16 8.03999 13.16C7.59999 13.16 7.23999 12.8 7.23999 12.36V9.56005C7.23999 4.72805 11.168 0.800049 16 0.800049C20.832 0.800049 24.76 4.72805 24.76 9.56005V12.36C24.76 12.808 24.4 13.16 23.96 13.16Z",
    fill: "#353EBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 21.9281C17.4051 21.9281 18.5441 20.7891 18.5441 19.3841C18.5441 17.9791 17.4051 16.8401 16.0001 16.8401C14.595 16.8401 13.4561 17.9791 13.4561 19.3841C13.4561 20.7891 14.595 21.9281 16.0001 21.9281Z",
    fill: "#353EBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.912C15.56 25.912 15.2 25.552 15.2 25.112V19.392C15.2 18.952 15.56 18.592 16 18.592C16.44 18.592 16.8 18.952 16.8 19.392V25.112C16.8 25.552 16.44 25.912 16 25.912Z",
    fill: "#353EBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.8453758717bbacd658ff712fe1cca719.svg";
export { ForwardRef as ReactComponent };